export default class NoticeHelper {
  static get TYPE_SUCCESS() {
    return 'success'
  }

  static get TYPE_WARNING() {
    return 'warning'
  }

  static get TYPE_ERROR() {
    return 'error'
  }

  static createSuccessObj(message) {
    return this.createObj(this.TYPE_SUCCESS, message)
  }

  static createWarningObj(message) {
    return this.createObj(this.TYPE_WARNING, message)
  }

  static createErrorObj(message) {
    return this.createObj(this.TYPE_ERROR, message)
  }

  static createObj = (type, message) => ({
    type,
    message,
  })
}
